module.exports = __webpack_public_path__ + "img/first_bg01.218b4e24.png";